/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ClothesAccsNecktieIcon16Light } from './ClothesAccsNecktieIcon16Light';
import { ClothesAccsNecktieIcon16Regular } from './ClothesAccsNecktieIcon16Regular';
import { ClothesAccsNecktieIcon16Solid } from './ClothesAccsNecktieIcon16Solid';
import { ClothesAccsNecktieIcon20Light } from './ClothesAccsNecktieIcon20Light';
import { ClothesAccsNecktieIcon20Regular } from './ClothesAccsNecktieIcon20Regular';
import { ClothesAccsNecktieIcon20Solid } from './ClothesAccsNecktieIcon20Solid';
import { ClothesAccsNecktieIcon24Regular } from './ClothesAccsNecktieIcon24Regular';
import { ClothesAccsNecktieIcon24Solid } from './ClothesAccsNecktieIcon24Solid';
import { ClothesAccsNecktieIcon32Regular } from './ClothesAccsNecktieIcon32Regular';
import { ClothesAccsNecktieIcon64Regular } from './ClothesAccsNecktieIcon64Regular';
var sizes = {
    16: {
        light: ClothesAccsNecktieIcon16Light,
        regular: ClothesAccsNecktieIcon16Regular,
        solid: ClothesAccsNecktieIcon16Solid,
    },
    20: {
        light: ClothesAccsNecktieIcon20Light,
        regular: ClothesAccsNecktieIcon20Regular,
        solid: ClothesAccsNecktieIcon20Solid,
    },
    24: {
        regular: ClothesAccsNecktieIcon24Regular,
        solid: ClothesAccsNecktieIcon24Solid,
    },
    32: {
        regular: ClothesAccsNecktieIcon32Regular,
    },
    64: {
        regular: ClothesAccsNecktieIcon64Regular,
    },
};
export var ClothesAccsNecktieIcon = forwardRef('ClothesAccsNecktieIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
